import Inherit from '../../core/inherit';
import ShelfController from '../../core/shelf.controller';
import TagsDelegate from './tags.delegate';
import { Modal } from 'antd';

const { confirm } = Modal;

class TagsController extends Inherit(ShelfController, TagsDelegate) {
    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.tags !== nextState.tags ||
            this.state.loading !== nextState.loading ||
            this.state.searchText !== nextState.searchText ||
            this.state.formModalVisible !== nextState.formModalVisible ||
            this.state.assignmentModalVisible !== nextState.assignmentModalVisible ||
            this.state.sosModalVisible !== nextState.sosModalVisible ||
            this.state.selectedTag !== nextState.selectedTag ||
            this.state.filterModelType !== nextState.filterModelType ||
            this.state.filterHasSOS !== nextState.filterHasSOS
        );
    }

    async initialize() {
        if (this.isAuthenticated) {
            await this.fetchTags();
        } else {
            this.navigateLogin();
        }
    }

    async fetchTags() {
        this.setState({ loading: true });
        try {
            const { searchText, filterModelType, filterHasSOS } = this.state;
            const filters = {};

            if (filterModelType) filters.modelType = filterModelType;
            if (filterHasSOS !== null) filters.hasSosTargets = filterHasSOS;
            if (searchText) filters.search = searchText;

            const response = await this.data.requestTags(filters);
            this.setState({ tags: response.tags || [], loading: false });
        } catch (error) {
            const { onMessage } = this.props;
            onMessage('error', 'Error al cargar etiquetas: ' + (error.response?.data?.message || error.message));
            this.setState({ loading: false });
        }
    }

    handleSearch() {
        this.fetchTags();
    }

    /** Picking a suggestion searches right away. */
    selectSearch(value) {
        this.setSearchText(value);
        this.handleSearch();
    }

    /** "Con SOS" toggle: only tags with SOS targets ↔ all tags. */
    toggleSOSFilter() {
        const newValue = this.state.filterHasSOS === true ? null : true;
        this.setFilterHasSOS(newValue);
        this.setState({ filterHasSOS: newValue }, () => this.fetchTags());
    }

    handleCreate() {
        this.setState({ selectedTag: null, formModalVisible: true });
    }

    handleEdit(tag) {
        this.setState({ selectedTag: tag, formModalVisible: true });
    }

    handleDelete(tag) {
        const { onMessage } = this.props;

        confirm({
            title: '¿Eliminar etiqueta?',
            content: `¿Estás seguro de eliminar la etiqueta "${tag.name}"? Esto removerá la etiqueta de todos los elementos.`,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk: async () => {
                try {
                    await this.data.requestDeleteTag(tag._id);
                    onMessage('success', 'Etiqueta eliminada correctamente');
                    this.fetchTags();
                } catch (error) {
                    onMessage('error', 'Error al eliminar etiqueta: ' + (error.response?.data?.message || error.message));
                }
            }
        });
    }

    handleAssign(tag) {
        this.setState({ selectedTag: tag, assignmentModalVisible: true });
    }

    handleViewSOS(tag) {
        // Navigate to SOS Analysis page with this tag pre-selected
        this.props.navigate(`/dashboard/sos-analysis?tagId=${tag._id}`);
    }

    handleFormSuccess() {
        this.setState({ formModalVisible: false, selectedTag: null });
        this.fetchTags();
    }

    handleAssignmentSuccess() {
        this.setState({ assignmentModalVisible: false, selectedTag: null });
        this.fetchTags();
    }
}

export default TagsController;
